// Mock data for Spark Invotech website

export const companyInfo = {
  name: "Spark Invotech",
  tagline: "Bridging Industry and Innovation.",
  subheading: "Empowering industries with intelligent IoT, automation, and cloud-based solutions.",
  email: "contact@sparkinvotech.com",
  website: "www.sparkinvotech.com",
  location: "Sairam Institutions Campus, Chennai, Tamil Nadu, India"
};

export const aboutContent = {
  title: "About Us",
  description: "At Spark Invotech, we bridge the gap between industry and innovation. We specialize in developing intelligent IoT-based solutions that drive efficiency, automation, and sustainability. Our team of experts combines cutting-edge technology with deep industry knowledge to deliver transformative solutions that empower businesses to thrive in the digital age."
};

export const products = [
  {
    id: 1,
    name: "Cloud Fusion Logger",
    description: "Advanced IoT data logging and analytics system for real-time monitoring and insights.",
    features: [
      "Real-time data capture from multiple sensors",
      "Cloud-based storage and analytics",
      "Customizable dashboards and alerts",
      "Seamless integration with existing systems"
    ],
    applications: [
      "Manufacturing process monitoring",
      "Energy consumption tracking",
      "Environmental monitoring",
      "Asset performance management"
    ]
  },
  {
    id: 2,
    name: "OEE Monitoring Dashboard",
    description: "Comprehensive real-time machine performance analytics for maximum operational efficiency.",
    features: [
      "Live OEE calculation and visualization",
      "Downtime analysis and reporting",
      "Production efficiency metrics",
      "Predictive maintenance alerts"
    ],
    applications: [
      "Production line optimization",
      "Equipment effectiveness tracking",
      "Quality control monitoring",
      "Maintenance scheduling"
    ]
  }
];

export const services = [
  {
    id: 1,
    name: "IoT Product Development",
    description: "End-to-end IoT solution development from concept to deployment, tailored to your specific industry needs.",
    icon: "Cpu"
  },
  {
    id: 2,
    name: "Industrial Automation & Monitoring",
    description: "Smart automation systems that optimize operations, reduce costs, and enhance productivity across industries.",
    icon: "Gauge"
  },
  {
    id: 3,
    name: "Web & Cloud Integration",
    description: "Seamless integration of web and cloud technologies to enable remote monitoring and data-driven decision making.",
    icon: "Cloud"
  },
  {
    id: 4,
    name: "Prototype to Product Support",
    description: "Complete support from initial prototype development to full-scale production, ensuring quality at every stage.",
    icon: "Rocket"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "Manufacturing Solutions Ltd.",
    text: "Spark Invotech transformed our production monitoring with their OEE Dashboard. Real-time insights have helped us increase efficiency by 35%.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    company: "Tech Innovations Inc.",
    text: "Their IoT solutions are cutting-edge. The Cloud Fusion Logger has revolutionized how we track and analyze our operational data.",
    rating: 5
  },
  {
    id: 3,
    name: "Arun Patel",
    company: "Industrial Automation Group",
    text: "Professional, innovative, and reliable. Spark Invotech delivered beyond our expectations with their automation solutions.",
    rating: 5
  }
];

export const images = {
  heroBackground: "https://images.unsplash.com/photo-1625571705670-38fc39c923ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxJb1QlMjBkZXZpY2VzfGVufDB8fHx8MTc2MTkyODQ0Nnww&ixlib=rb-4.1.0&q=85",
  aboutTech: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=800&h=600&fit=crop&q=80",
  iotDevices: "https://images.unsplash.com/photo-1596658591534-591d75e2f2f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxJb1QlMjBkZXZpY2VzfGVufDB8fHx8MTc2MTkyODQ0Nnww&ixlib=rb-4.1.0&q=85",
  automation: "https://images.unsplash.com/photo-1761195696590-3490ea770aa1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxhdXRvbWF0aW9uJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NjE5Mjg0NTF8MA&ixlib=rb-4.1.0&q=85",
  industrial: "https://images.unsplash.com/photo-1689942009554-759940987be0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxhdXRvbWF0aW9uJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NjE5Mjg0NTF8MA&ixlib=rb-4.1.0&q=85",
  industrialMachine: "https://images.unsplash.com/photo-1689942007817-679c21614b25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxhdXRvbWF0aW9uJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NjE5Mjg0NTF8MA&ixlib=rb-4.1.0&q=85"
};
